import { createSelector } from 'reselect'

import { getCurrentHandle } from '../current/selectors'

export const getRoutes = createSelector(
  [getCurrentHandle, (state) => state.routes],
  (handle, routes) => {
    return mapRoutes(handle, routes, false)
  },
)

export const getRoutesWithoutPrefill = createSelector(
  [getCurrentHandle, (state) => state.routes],
  (handle, routes) => {
    return mapRoutes(handle, routes, true)
  },
)

export const getAppRoutes = createSelector(
  [(state) => state.routes],
  (routes) => {
    return filterRoutesByScope(routes, 'admin_app')
  },
)

const filterRoutesByScope = (routes, scope) => {
  return Object.keys(routes).reduce((acc, routeName) => {
    if (routeName.includes(scope)) {
      acc[routeName] = routes[routeName]
    }
    return acc
  }, {})
}

const mapRoutes = (handle, routes, ignorePrefill) => {
  return Object.keys(routes).reduce((result, route) => {
    result[route] = {
      ...routes[route],
      ...{
        path: ignorePrefill
          ? routes[route].path
          : routes[route].path.replace(':current_handle', handle),
      },
    }
    return result
  }, {})
}
